const emptyArray: never[] = []
Object.freeze(emptyArray)

const emptyObject: Record<string, any> = {}
Object.freeze(emptyObject)

// eslint-disable-next-line @typescript-eslint/no-empty-function
function noop() {}
Object.freeze(noop)

export { emptyArray, emptyObject, noop }
